const API_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

class DateTimeHelper {

    /**
     * @returns {string}
     */
    static get apiDateTimeFormat() {
        return API_DATE_TIME_FORMAT;
    }
}

export default DateTimeHelper;
